'use client'
import { AppKit } from '@reown/appkit'
import { useAtom } from 'jotai'
import { useEffect } from 'react'

import { Button, Trans } from '@/components'
import { modal } from '@/contexts'
import { atomLoginStatus } from '@/stores/login'

export default function WalletsDialog() {
  const [loginStatus] = useAtom(atomLoginStatus)
  useEffect(() => {
    (window as unknown as Window & { modal: AppKit }).modal = modal
  }, [])

  if (loginStatus !== 'initial') return null

  return (
    <Button
      type="secondary"
      block
      className="mt-2"
      onClick={async () => {
        try {
          await modal.disconnect()

          modal.open({ view: 'Connect' })
          let address = await modal.getAddress()
          while (address) {
            await modal.disconnect()
            address = await modal.getAddress()
          }
        } catch (error) {
          console.error(error)
        }
      }}
    >
      <Trans i18nKey="login.loginBtnByWallet">Connect Wallet</Trans>
    </Button>
  )
}
